const getInsertableIndex = (elementIndex, elementsPerRow, elementCount) => {
  if (elementIndex >= elementCount) {
    throw new Error(`elementIndex (${elementIndex}) cannot be greater or equal to elementCount (${elementCount}) `)
  }
  return Math.min(elementIndex + elementsPerRow - elementIndex % elementsPerRow, elementCount)
}

export default getInsertableIndex